// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeader_container__2RGYL","breadcrumb":"PageHeader_breadcrumb__1Qa_c","title":"PageHeader_title__7l-wW"};